import { Button, Modal, Form, Row, Col, Input, Select, message } from "antd";
import React, { useEffect, useState } from "react";
import createVehicle from "../../../../services/createVehicle";
import Dragger from "antd/lib/upload/Dragger";
import { InboxOutlined } from '@ant-design/icons';
import * as XLSX from "xlsx";
import _ from "lodash";
import uploadVehicle from "../../../../services/uploadVehicle";

const { Option } = Select;
const { TextArea } = Input;

export default function UploadVehicle({ isVisible, hideModal, refetch }: any) {
  const [file, setFile] = useState<any>(null);
  const [isLoading, setLoading] = useState(false);
  const [vehicles, setVehicles] = useState(null);
  const [form] = Form.useForm();

  const onSubmit = async () => {

    let mapped = _.map(vehicles, (vehicle: any) => {
      return {
        registration: vehicle.__EMPTY || vehicle["CHASSIS NO"],
        model: vehicle.__EMPTY_1 || vehicle["MODEL/TYPE"]
      }
    })

    const withoutHeader = mapped.slice(1, mapped.length);

    uploadVehicle(JSON.stringify(mapped))
      .then(
        (upload: any) => {
          // console.log("this is the result", upload)
          message.success('Vehicles Uploaded Successfully')
        }
      ).catch((error: any) => {
        // console.log('error happened', error)
      })
      .finally(() => {
        // console.log('finally')
      })
    // if(upload.success){
    //     message.error(upload.message)
    // }else{
    //     message.success("Vehicles Uploaded")
    // }

    hideModal()
  };

  const clearForm = async () => {
    form.resetFields();
  };

  const props: any = {
    name: 'file',
    multiple: false,
    action: async (file: any) => {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        let data = e.target.result;
        let workbook = XLSX.read(data, {
          type: 'binary',
          raw: true,
        });

        let XL_row_object: any = XLSX.utils.sheet_to_json(
          workbook.Sheets[workbook.SheetNames[0]],
          {
            raw: true
          }
        );

        setVehicles(XL_row_object)
      }
      const data = reader.readAsBinaryString(file)

      return data;
    },

  };

  return (
    <Modal
      visible={isVisible}
      title="New Vehicle"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createVehicle"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createVehicle"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Form.Item>
          <Dragger {...props}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
            <p className="ant-upload-hint">
              Support for a single or bulk upload. Strictly prohibit from uploading company data or other
              band files
            </p>
          </Dragger>
        </Form.Item>
      </Form>
    </Modal>
  );
}
